import type { GtmEventProductImpressions } from '@packages/tracking';
import { useTracking } from '@packages/tracking';

import type { CurrentNavigation } from '../../api/rest/types';

import type { ActualSearchProductCardProps } from './SearchProductCard';

export const useProductImpressionTracking = (
  styleData: Pick<
    ActualSearchProductCardProps['product'],
    'brand' | 'title' | 'variations' | 'productPosition' | 'mkz'
  >,
  categoryData: {
    breadcrumbData?: CurrentNavigation[];
  },
) => {
  const { breadcrumbData } = categoryData;

  const dispatchGTMEvent = useTracking();

  const { brand, title, variations, productPosition, mkz } = styleData;

  const filteredBreadCrumb = breadcrumbData
    ? breadcrumbData.filter((item) => item.uriPath !== '/')
    : [];
  const customCategory = [...filteredBreadCrumb.map(({ name }) => name)].join('/');

  const dispatchProductImpressionTracking = () => {
    dispatchGTMEvent<GtmEventProductImpressions>({
      event: 'EECproductImpression',
      ecommerce: {
        currencyCode: 'EUR',
        impressions: [
          {
            name: title,
            position: productPosition || 0,
            brand: brand || '',
            id: variations[0].artNo,
            sku: variations[0].sku,
            price: variations[0].price.value,
            category: filteredBreadCrumb.length ? customCategory : mkz.category,
            list: filteredBreadCrumb.length ? `Category: ${mkz.category}` : 'Search Result',
          },
        ],
      },
    });
  };

  return { dispatchProductImpressionTracking };
};
